// extracted by mini-css-extract-plugin
export default {"app":"App_app__GNzSr","content":"App_content__sPDPP","section":"App_section__e7-aD"};